import { render, staticRenderFns } from "./ResetTip.vue?vue&type=template&id=13554770&scoped=true&"
import script from "./ResetTip.vue?vue&type=script&lang=js&"
export * from "./ResetTip.vue?vue&type=script&lang=js&"
import style0 from "./ResetTip.vue?vue&type=style&index=0&id=13554770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13554770",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\maixun_cxx\\private_library\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13554770')) {
      api.createRecord('13554770', component.options)
    } else {
      api.reload('13554770', component.options)
    }
    module.hot.accept("./ResetTip.vue?vue&type=template&id=13554770&scoped=true&", function () {
      api.rerender('13554770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ResetTip.vue"
export default component.exports